import React, { useContext, useEffect, useState } from "react";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import WeekPicker from "../../components/WeekPicker";
import RadioButton from "../../components/RadioButton";
import Input from "../../components/Input";
import TextArea from "../../components/TextArea";
import { AppContext } from "../../context/app.context";
import { ScheduleContext } from "../../context/schedule.context";
import { ModelTsContext } from "../../context/modelTS.context";
// ModelRwContext removed - Realm EOL Jan 13, 2026
import {
  COLUMN_DAY_ARRAY,
  // FILTERS_SURFACE_ARRAY,
  CAPACITIES_SURFACE_ARRAY,
} from "../../utility/keys";
import Checkbox from "../../components/Checkbox";

// enums for tab
// 2025-01-08 - temporarilry removing defaults until I can fix them 100%
const Tabs = Object.freeze({
  AVAILABILITY: "Availability",
  DEFAULTS: "Availability Defaults",
  CAPACITIES: "Capacities",
  ATTRIBUTES: "Attributes",
  NOTES: "Notes",
});

// enums for tab
const Statuses = Object.freeze({
  AVAILABILITY: "Available",
  OFF: "OFF",
  BUFFER: "BUFFER",
  CUSTOM: "Custom",
});

const CAPACITIES_HEADER = [
  "",
  "Sequence",
  "Once / Day",
  "Furn / Day",
  "Step / Day",
  "Twice / Day",
  "Furn / Day",
  "Step / Day",
];

// const mockedLaborAttributes =
//   "Cut Doors\rDifficult / Gate Access\rFurniture/Appliances\rHard Surface\rHard Surface Removal\rInstall Molding\rSoft Surface Removal\rWood Pattern/Design\rWood Undercut Fireplace\rHard Surface Flooring\rCali Bamboo\rWood Stairs\rLaminate Stairs";

const PREDEFINED_LABOR_ATTRIBUTES_LIST = [
  {
    isChecked: false,
    title: "Cali Bamboo",
  },
  {
    isChecked: false,
    title: "Carpet Pattern/Design",
  },
  {
    isChecked: false,
    title: "Carpet Stairs",
  },
  {
    isChecked: false,
    title: "Cut Doors",
  },
  {
    isChecked: false,
    title: "Difficult / Gate Access",
  },
  {
    isChecked: false,
    title: "Drill/Glue Tackstrip",
  },
  {
    isChecked: false,
    title: "F&I Soundproof Membrane",
  },
  {
    isChecked: false,
    title: "Furniture/Appliances",
  },
  {
    isChecked: false,
    title: "Hard Surface",
  },
  {
    isChecked: false,
    title: "Hard Surface Flooring",
  },
  {
    isChecked: false,
    title: "Hard Surface Removal",
  },
  {
    isChecked: false,
    title: "Install Molding",
  },
  {
    isChecked: false,
    title: "Laminate Stairs",
  },
  {
    isChecked: false,
    title: "Mobile Home Work",
  },
  {
    isChecked: false,
    title: "Screw Down/Subfloor Work",
  },
  {
    isChecked: false,
    title: "Soft Surface Removal",
  },
  {
    isChecked: false,
    title: "Tile Pattern/Design",
  },
  {
    isChecked: false,
    title: "Travel Over 50 Miles",
  },
  {
    isChecked: false,
    title: "Wet Removal / Pet Soiled",
  },
  {
    isChecked: false,
    title: "Wood Pattern/Design",
  },
  {
    isChecked: false,
    title: "Wood Stairs",
  },
  {
    isChecked: false,
    title: "Wood Undercut Fireplace",
  },
];

function CrewDetailModal({ crewDetail, setOpenCrewDetailModal }) {
  const {
    weekDatesArray,
    onWeekToday,
    onWeekBehind,
    onWeekAhead,
    dataFormatting_payrollFields,
  } = useContext(AppContext);
  const { scheduleArray } = useContext(ScheduleContext);
  // Use TanStack directly (Realm EOL Jan 13, 2026)
  const { tsUpdateAttributeList, tsCreateCrewDefaultsAttribute, awsgwAttributesResult } =
    useContext(ModelTsContext);
  // Use TanStack attributes data
  const attributesList = awsgwAttributesResult || [];

  const [activeTab, setActiveTab] = useState(Tabs.AVAILABILITY);
  const [dayAttributes, setDayAttributes] = useState({});
  const [customValues, setCustomValues] = useState(Array(7).fill(""));
  const [dayAttributesDefault, setDayAttributesDefault] = useState({});
  const [customValuesDefault, setCustomValuesDefault] = useState(
    Array(7).fill("")
  );
  const [laborAttributesList, setLaborAttributesList] = useState(
    PREDEFINED_LABOR_ATTRIBUTES_LIST
  );
  // (#79) variable read removed — only the setter is used (set but never read).
  // eslint-disable-next-line no-unused-vars
  const [_laborAttributesValue, setLaborAttributesValue] = useState("");

  // these are in the same order and matching Recruiter Capacities tab
  const capacityValues = [
    [
      "carpet",
      crewDetail?.capacity_carpet_prime_secondary,
      crewDetail?.capacity_carpet_once,
      crewDetail?.capacity_carpet_once_furniture,
      crewDetail?.capacity_carpet_once_steps,
      crewDetail?.capacity_carpet_twice,
      crewDetail?.capacity_carpet_twice_furniture,
      crewDetail?.capacity_carpet_twice_steps,
    ],
    [
      "vinylPlank",
      crewDetail?.capacity_vinyl_prime_secondary,
      crewDetail?.capacity_vinyl_once,
      crewDetail?.capacity_vinyl_once_furniture,
      crewDetail?.capacity_vinyl_once_steps,
      crewDetail?.capacity_vinyl_twice,
      crewDetail?.capacity_vinyl_twice_furniture,
      crewDetail?.capacity_vinyl_twice_steps,
    ],
    [
      "vinylSheet",
      crewDetail?.capacity_vinylSheet_prime_secondary,
      crewDetail?.capacity_vinylSheet_once,
      crewDetail?.capacity_vinylSheet_once_furniture,
      crewDetail?.capacity_vinylSheet_once_steps,
      crewDetail?.capacity_vinylSheet_twice,
      crewDetail?.capacity_vinylSheet_twice_furniture,
      crewDetail?.capacity_vinylSheet_twice_steps,
    ],
    [
      "tile",
      crewDetail?.capacity_tile_prime_secondary,
      crewDetail?.capacity_tile_once,
      crewDetail?.capacity_tile_once_furniture,
      crewDetail?.capacity_tile_once_steps,
      crewDetail?.capacity_tile_twice,
      crewDetail?.capacity_tile_twice_furniture,
      crewDetail?.capacity_tile_twice_steps,
    ],
    [
      "backsplash",
      crewDetail?.capacity_backsplash_prime_secondary,
      crewDetail?.capacity_backsplash_once,
      crewDetail?.capacity_backsplash_once_furniture,
      crewDetail?.capacity_backsplash_once_steps,
      crewDetail?.capacity_backsplash_twice,
      crewDetail?.capacity_backsplash_twice_furniture,
      crewDetail?.capacity_backsplash_twice_steps,
    ],
    [
      "floating",
      crewDetail?.capacity_floating_prime_secondary,
      crewDetail?.capacity_floating_once,
      crewDetail?.capacity_floating_once_furniture,
      crewDetail?.capacity_floating_once_steps,
      crewDetail?.capacity_floating_twice,
      crewDetail?.capacity_floating_twice_furniture,
      crewDetail?.capacity_floating_twice_steps,
    ],
    [
      "glueDown",
      crewDetail?.capacity_glueDown_prime_secondary,
      crewDetail?.capacity_glueDown_once,
      crewDetail?.capacity_glueDown_once_furniture,
      crewDetail?.capacity_glueDown_once_steps,
      crewDetail?.capacity_glueDown_twice,
      crewDetail?.capacity_glueDown_twice_furniture,
      crewDetail?.capacity_glueDown_twice_steps,
    ],
    [
      "nailDown",
      crewDetail?.capacity_nailDown_prime_secondary,
      crewDetail?.capacity_nailDown_once,
      crewDetail?.capacity_nailDown_once_furniture,
      crewDetail?.capacity_nailDown_once_steps,
      crewDetail?.capacity_nailDown_twice,
      crewDetail?.capacity_nailDown_twice_furniture,
      crewDetail?.capacity_nailDown_twice_steps,
    ],
    ["interiorDoors", crewDetail?.capacity_internal_doors],
    ["exteriorDoors", crewDetail?.capacity_external_doors],
    ["stormDoors", crewDetail?.capacity_storm_doors],
    ["windows", crewDetail?.capacity_windows],
  ];

  // -------
  const getSelectedStatus = (dayIndex) => {
    if (activeTab === Tabs.AVAILABILITY) {
      return (
        dayAttributes[weekDatesArray[dayIndex]] || {
          status: Statuses.AVAILABILITY,
        }
      );
    } else {
      return (
        dayAttributesDefault[dayIndex] || {
          status: Statuses.AVAILABILITY,
        }
      );
    }
  };

  // ------

  const getCustomValues = (dayIndex) => {
    if (activeTab === Tabs.AVAILABILITY) {
      return customValues[dayIndex];
    } else {
      return customValuesDefault[dayIndex];
    }
  };

  // -------

  const onChangeStatus = (status, dayIndex, customText = "") => {
    const installer = dataFormatting_payrollFields(crewDetail?.payrollNo);
    const date = new Date(weekDatesArray[dayIndex]).toLocaleDateString("en-us");
    console.log(
      "CrewDetailModal onChangeStatus, date: ",
      date,
      ", installer: ",
      installer,
      ", status: ",
      status
    );
    if (activeTab === Tabs.AVAILABILITY) {
      // availability - save changes to Attributes list and push to Mongo
      // Use TanStack directly (Realm EOL Jan 13, 2026)
      tsUpdateAttributeList(date, installer, status, customText);
    } else {
      // all other changes, which appears to only be DEFAULTS
      if (status !== Statuses.CUSTOM && customValuesDefault[dayIndex]) {
        customValuesDefault[dayIndex] = "";
        setCustomValuesDefault([...customValuesDefault]);
      }

      // local changes
      var newArray = [];
      if (status === "Available") {
        newArray = {
          ...dayAttributesDefault,
        };
        // wipe out Available array element
        delete newArray[dayIndex];
      } else {
        newArray = {
          ...dayAttributesDefault,
          [dayIndex]: { status, custom: customText },
        };
      }
      setDayAttributesDefault(newArray);
      console.log(
        "CrewDetailModal onChangeStatus, setDayAttributesDefault: ",
        newArray,
        ", setCustomValuesDefault: ",
        customValuesDefault
      );

      // state & Collection changes
      // Use TanStack directly (Realm EOL Jan 13, 2026)
      tsCreateCrewDefaultsAttribute(installer, newArray, customValuesDefault);
    }
  };

  // -----------

  const saveCustomStatus = (dayIndex) => {
    if (activeTab === Tabs.AVAILABILITY) {
      if (
        customValues[dayIndex] !==
        (dayAttributes[weekDatesArray[dayIndex]]?.custom || "")
      ) {
        if (customValues[dayIndex]) {
          onChangeStatus(
            Statuses.CUSTOM,
            dayIndex,
            customValues[dayIndex] || ""
          );
        } else {
          onChangeStatus(Statuses.AVAILABILITY, dayIndex);
        }
      }
    } else {
      if (
        customValuesDefault[dayIndex] !==
        (dayAttributesDefault[dayIndex]?.custom || "")
      ) {
        if (customValuesDefault[dayIndex]) {
          onChangeStatus(
            Statuses.CUSTOM,
            dayIndex,
            customValues[dayIndex] || ""
          );
        } else {
          onChangeStatus(Statuses.AVAILABILITY, dayIndex);
        }
      }
    }
  };

  // -----------

  const onCustomChange = (value, dayIndex) => {
    if (activeTab === Tabs.AVAILABILITY) {
      customValues[dayIndex] = value;
      setCustomValues([...customValues]);
    } else {
      customValuesDefault[dayIndex] = value;
      setCustomValuesDefault([...customValuesDefault]);
    }
  };

  // -------

  // (#79) Handler defined but never wired to a UI element. Kept as scaffolding
  // for the labor-attributes feature; underscore prefix marks intentional retention.
  // eslint-disable-next-line no-unused-vars
  const _onLaborAttributeChanged = (event, attributeIndex) => {
    const value = event.target.checked;
    setLaborAttributesList(() =>
      laborAttributesList.map((attribute, index) => {
        if (attributeIndex === index) {
          return {
            isChecked: value,
            title: attribute.title,
          };
        }
        return attribute;
      })
    );
    setLaborAttributesValue(
      laborAttributesList
        .filter((a) => a.isChecked)
        .map((a) => a.title)
        .join("\r")
    );
  };

  // - - - - - - - - - - - - - - - - -  EFFECT HOOKS  - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - -

  useEffect(() => {
    const newDayAttributes = scheduleArray.reduce((prev, curr) => {
      // in scheduleArray, all attributes added after all jobs have attribute=true
      // and all payrollNos have already had dataFormatting_payrollFields() applied
      // 2025-02-11 - added filter for availability to prevent defaults from being included
      if (
        dataFormatting_payrollFields(crewDetail?.payrollNo) ===
          curr.installer &&
        curr.attribute &&
        curr.availability.length === 0
      ) {
        switch (curr?.encodedSmallTitle) {
          case Statuses.BUFFER:
            prev[curr.start] = {
              status: Statuses.BUFFER,
            };
            break;
          case Statuses.OFF:
            prev[curr.start] = {
              status: Statuses.OFF,
            };
            break;

          default:
            prev[curr.start] = {
              status: Statuses.CUSTOM,
              custom: curr?.encodedSmallTitle.replaceAll("🔥", ""),
            };
            break;
        }
      }
      return prev;
    }, {});

    console.log(
      "CrewDetailModal useEffect[crewDetail, scheduleArray], newDayAttributes: ",
      newDayAttributes
    );

    setDayAttributes(newDayAttributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crewDetail, scheduleArray]);

  // -------

  useEffect(() => {
    const newAvailability = attributesList.filter(
      (attr) =>
        attr._kf_payrollNo ===
          dataFormatting_payrollFields(crewDetail.payrollNo) &&
        attr.date === "" &&
        attr.availability.length > 0
    );
    console.log(
      "CrewDetailModel useEffect[attributeList, crewDetail] dayAttributesDefault: ",
      newAvailability
    );
    if (newAvailability.length) {
      const newAttributeList = newAvailability[
        newAvailability.length - 1
      ].availability.reduce((prev, curr) => {
        const [day, status] = Object.entries(curr)[0];
        const dayIndex = COLUMN_DAY_ARRAY.findIndex((el) => el === day);

        if (dayIndex >= 0) {
          switch (status) {
            case Statuses.BUFFER:
              prev[dayIndex] = {
                status: Statuses.BUFFER,
              };
              break;
            case Statuses.OFF:
              prev[dayIndex] = {
                status: Statuses.OFF,
              };
              break;

            default:
              // For defaults, the custom text is in the 'status' variable (extracted from availability array)
              // e.g., { Mon: "🔥custom text🔥" } -> status = "🔥custom text🔥"
              // Strip flame emojis for display in the text input
              prev[dayIndex] = {
                status: Statuses.CUSTOM,
                custom: status?.replaceAll("🔥", ""),
              };
              break;
          }
        }
        return prev;
      }, {});
      console.log(
        "CrewDetailModel useEffect[attributeList, crewDetail] newAttributeList: ",
        newAttributeList
      );
      setDayAttributesDefault(newAttributeList);

      // Also populate customValuesDefault with the custom text for each day
      // This ensures the text input fields show the existing custom values
      const newCustomValues = Array(7).fill("");
      Object.entries(newAttributeList).forEach(([dayIndex, attr]) => {
        if (attr.status === Statuses.CUSTOM && attr.custom) {
          newCustomValues[parseInt(dayIndex)] = attr.custom;
        }
      });
      setCustomValuesDefault(newCustomValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributesList, crewDetail]);

  // -------

  useEffect(() => {
    const newCustomValues = weekDatesArray.map(
      (value) => dayAttributes[value]?.custom || ""
    );

    // console.log(
    //   "CrewDetailModal useEffect[weekDatesArray, dayAttributes], newCustomValues: ",
    //   newCustomValues
    // );

    setCustomValues(newCustomValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weekDatesArray, dayAttributes]);

  // ------

  useEffect(() => {
    const laborAttributesArr = crewDetail?.LaborAttributes.split(/[\n\r]/).map(
      (attribute) => attribute.replace(/\s\/\s/g, "/")
    );
    // AIchat:  The code attribute.replace(/\s\/\s/g, "/") takes a string
    //          stored in the variable attribute and replaces all occurrences
    //          of a space, followed by a forward slash, followed by a
    //          space (" / ") with just a forward slash ("/").

    setLaborAttributesList(() =>
      laborAttributesList.map((attribute) => ({
        ...attribute,
        isChecked: laborAttributesArr.indexOf(attribute.title) > -1,
      }))
    );
    setLaborAttributesValue(laborAttributesArr.join("\r"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------

  return (
    <Modal onClose={() => setOpenCrewDetailModal({ show: false })}>
      <Modal.Header>Crew: {crewDetail?.Name_Full}</Modal.Header>
      <Modal.Content>
        {crewDetail ? (
          <div className="flex flex-col gap-4 w-[984px]">
            <div className="text-lg font-bold">General Info</div>
            <div className="pb-4 flex gap-2.5">
              <div className="flex-1 grid grid-cols-[100px_auto]">
                <div>Name</div>
                <div className="font-bold">{crewDetail.Name_Full}</div>
                <div>Crew Type</div>
                <div className="font-bold">{crewDetail.RecordType}</div>
                <div>Surface</div>
                <div className="font-bold">{crewDetail.Scheduling_Surface}</div>
                <div>Payroll#</div>
                <div className="font-bold">
                  {dataFormatting_payrollFields(crewDetail.payrollNo)}
                </div>
              </div>
              <div className="flex-1 grid grid-cols-[100px_auto] content-start">
                <div>Phone</div>
                <div className="font-bold">{crewDetail.Phone1}</div>
                <div>Email</div>
                <div className="font-bold text-skin-link">
                  {crewDetail.Email}
                </div>
              </div>
            </div>
            <div className="w-full border-b border-b-yellow-30 ">
              {Object.values(Tabs).map((label, index) => (
                <Button
                  key={index}
                  className={`${
                    activeTab === label
                      ? "bg-opacity-30 font-semibold"
                      : "bg-opacity-5"
                  }  py-2 text-skin-primary`}
                  onClick={() => setActiveTab(label)}
                >
                  {label}
                </Button>
              ))}
            </div>
            <div className="pb-4 ">
              {activeTab === Tabs.NOTES ? (
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-1 p-2 bg-skin-surface-hard">
                    <div>
                      <TextArea
                        readOnly={true}
                        placeholder="Custom Notes"
                        rows={20}
                        value={crewDetail?.SchedulerNotes}
                        className="bg-skin-base border border-black border-opacity-20 "
                      ></TextArea>
                    </div>
                  </div>
                  <div></div>
                </div>
              ) : activeTab === Tabs.ATTRIBUTES ? (
                <div className="grid grid-cols-2 gap-1 p-2 bg-skin-surface-hard">
                  {laborAttributesList.map((attribute, index) => (
                    <Checkbox
                      key={index}
                      value={attribute.isChecked}
                      label={attribute.title}
                      checked={attribute.isChecked}
                      disabled
                    />
                  ))}
                </div>
              ) : activeTab !== Tabs.CAPACITIES ? (
                <div className="flex flex-col gap-4">
                  {activeTab === Tabs.AVAILABILITY ? (
                    <div className="flex gap-4 h-6">
                      <Button onClick={() => onWeekToday()}>Today</Button>
                      <WeekPicker
                        value={weekDatesArray[0]}
                        weekBehind={() => onWeekBehind()}
                        weekAhead={() => onWeekAhead()}
                      ></WeekPicker>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="flex gap-2">
                    {COLUMN_DAY_ARRAY.map((day, dayIndex) => (
                      <div className="flex-1" key={dayIndex}>
                        <div
                          className={`${
                            dayIndex < 5 ? "bg-header" : "bg-header-lighter"
                          }
                        text-white border-b-2 border-b-yellow flex justify-center py-2`}
                        >
                          {day}&nbsp;
                          {activeTab === Tabs.AVAILABILITY
                            ? weekDatesArray[dayIndex]
                            : ""}
                        </div>
                        <div className="flex flex-col gap-1 p-2 bg-skin-surface-hard">
                          {Object.values(Statuses).map((value, index) => (
                            <RadioButton
                              key={index}
                              value={value}
                              checked={
                                value === getSelectedStatus(dayIndex)?.status
                              }
                              onChange={(e) =>
                                onChangeStatus(e.target.defaultValue, dayIndex)
                              }
                            >
                              {value}
                            </RadioButton>
                          ))}
                          <div className="w-[100px] mx-auto h-6">
                            <Input
                              placeholder="Custom"
                              value={getCustomValues(dayIndex)}
                              onChange={(e) =>
                                onCustomChange(e.target.value, dayIndex)
                              }
                              onBlur={() => saveCustomStatus(dayIndex)}
                              className="bg-skin-base border border-black border-opacity-20 "
                            ></Input>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  <div className="flex gap-2">
                    {CAPACITIES_HEADER.map((label, headerIndex) => (
                      <div className="flex-1" key={headerIndex}>
                        <div
                          className={`${
                            headerIndex > 1 && headerIndex < 5
                              ? "bg-header"
                              : headerIndex < 2
                              ? " "
                              : "bg-header-lighter"
                          } ${
                            headerIndex > 1 ? "text-white" : ""
                          } border-b-2 border-b-yellow flex justify-center py-2`}
                        >
                          {label ? label : "\u00A0"}
                        </div>
                        <div
                          className={`${
                            headerIndex > 1 ? "bg-skin-primary" : ""
                          } p-2 shadow-4 flex flex-col gap-2`}
                        >
                          {CAPACITIES_SURFACE_ARRAY.map(
                            (surface, surfaceIndex) => (
                              <div
                                key={surfaceIndex}
                                className="flex gap-2 h-6 items-center"
                              >
                                {headerIndex === 0 ? surface.name : ""}
                                {headerIndex === 1 ? (
                                  <div className="bg-skin-base">
                                    {capacityValues[surfaceIndex][headerIndex]}
                                  </div>
                                ) : (
                                  ""
                                )}
                                {headerIndex > 1 ? (
                                  <div className="bg-skin-base w-full px-2 text-right leading-6">
                                    {capacityValues[surfaceIndex][headerIndex]}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          "Job not found"
        )}
      </Modal.Content>
      <Modal.Footer>
        <div className="h-8 flex">
          <Button
            color="light"
            className="uppercase w-31"
            onClick={() => setOpenCrewDetailModal({ show: false })}
          >
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CrewDetailModal;
